import { Box, Menu, Button, MenuItem } from "@mui/material";
import {DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridCsvExportMenuItem, GridPrintExportMenuItem} from "@mui/x-data-grid";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import { tokens } from "../theme";

export const CustomGridToolbar = ({ onExport }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <GridToolbarContainer>
      {/* Default toolbar buttons */}
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />

      {/* Export button with dropdown */}
      <Button
        onClick={handleMenuOpen}
        variant="text"
        startIcon={<FileDownloadIcon />}
        sx={{mt: 0.2, ml: 0, color: "#ffffff", fontSize: "0.75rem", textTransform: "none"}}
      >
        Export
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            backgroundColor: "#2c2c2c",
            color: "#fff",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            onExport();
          }}
        >
          Download as CSV
        </MenuItem>

        {/* Optional: default MUI print option */}
        {/* <GridCsvExportMenuItem options={{ disableToolbarButton: true }} /> */}
        <GridPrintExportMenuItem options={{ disableToolbarButton: false }}
        />
      </Menu>
    </GridToolbarContainer>
  );
};

export const CustomTableRenderer = ({
  columns,
  data,
  id,
  paginationMode,
  rowCount,
  pageSizeOptions,
  paginationModel,
  onPaginationModelChange,
  handleExportCSV,
  loading = false,
  height = "60vh"
}) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      display="grid"
      width="100%"
      height={height}
      sx={{
        "& .MuiDataGrid-root": {
          border: "none",
        },
        "& .MuiDataGrid-cell": {
          borderBottom: "none",
          fontSize: "15px",
        },
        "& .name-column--cell": {
          color: colors.primary[100],
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: colors.blueAccent[700],
          border: "none",
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: colors.primary[400],
        },
        "& .MuiDataGrid-footerContainer": {
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
        },
        "& .MuiCheckbox-root": {
          color: `${colors.greenAccent[200]} !important`,
        },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
          color: `${colors.redAccent[100]} !important`,
        },
      }}
    >
      <DataGrid
        rows={data}
        columns={columns}
        getRowId={(row) => row[id]}
        paginationMode={paginationMode}
        rowCount={rowCount}
        pageSizeOptions={pageSizeOptions}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        components={{ Toolbar: CustomGridToolbar }}
        componentsProps={{
          toolbar: {
            onExport: handleExportCSV,
          },
        }}
        loading={loading}
      />
    </Box>
  );
};
